
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export const DocumentDialogTicket = ({
  openModalL,
  closeModalL,
  data
}) => {

  const [scroll, setScroll] = useState("paper");
  console.log(data);
  const handleCloseL = () => {
    // setOpen(false);
    // setProcess(false);
    closeModalL(false);
  };

  return (
    <Dialog
      // maxWidth="xl"
      fullWidth="md"
      maxWidth="md"
      open={openModalL}
      onClose={handleCloseL}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle>
        <h3>Alumno: {data?.data?.userFullName}</h3>
        <h5>Seccion: {data?.data?.sectionName}</h5>
      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        <table className="table table-striped mt-4">
          <thead>
            <tr>
              <th rowSpan={1}>#</th>
              <th rowSpan={2}>Asignatura</th>
              <th className="w100 text-center" colSpan={2}>Practica 1</th>
              {/* <th className="w100 text-center" colSpan={2}>Inter. Oral</th> */}
              <th className="w100 text-center" colSpan={2}>Examen Parcial</th>
              <th className="w100 text-center" colSpan={2}>Responsabilidad</th>
              <th className="w100 text-center" colSpan={2}>Cuaderno</th>
              {/* <th className="w100 text-center" colSpan={2} style={{backgroundColor: '#5d2837', color:'white'}}>Promedio Final</th> */}
            </tr>
            <tr>
              
            </tr>
          </thead>
          <tbody>
            {data?.courses?.map((course, i) => (
              <tr key={course.id} style={String(course.id).includes("a") ? {background: '#5d2837', color: 'white'} : {}} >
                <td>{i + 1}</td>
                <td>{course.name}</td>
                <td>{course.scores.p1.score}</td>
                <td>{course.scores.p1.letterScore}</td>
                {/* <td>{course.scores.p2.score}</td>
                <td>{course.scores.p2.letterScore}</td> */}
                <td>{course.scores.eXP.score}</td>
                <td>{course.scores.eXP.letterScore}</td>
                <td>{course.scores.rES.score}</td>
                <td>{course.scores.rES.letterScore}</td>
                <td>{course.scores.cUA.score}</td>
                <td>{course.scores.cUA.letterScore}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
};
